import { JsonProperty } from 'json-typescript-mapper';

export class Maintenance {

  @JsonProperty('id')
  public id?: number;

  @JsonProperty('startDate')
  public startDate?: string;

  @JsonProperty('endDate')
  public endDate?: string;

  @JsonProperty('startTime')
  public startTime?: string;

  @JsonProperty('endTime')
  public endTime?: string;

  @JsonProperty('type')
  public type?: string;

  @JsonProperty('message')
  public message?: string;

  @JsonProperty('announcement')
  public announcement?: string;

  @JsonProperty('announcementStart')
  public announcementStart?: string;

  @JsonProperty('created')
  public created?: string;

  @JsonProperty('updated')
  public updated?: string;

  @JsonProperty('createdByContactId')
  public createdByContactId?: number;

  @JsonProperty('updatedByContactId')
  public updatedByContactId?: number;

  constructor() {
    this.id = void 0;
    this.startDate = void 0;
    this.endDate = void 0;
    this.startTime = void 0;
    this.endTime = void 0;
    this.type = void 0;
    this.message = void 0;
    this.announcement = void 0;
    this.announcementStart = void 0;
    this.created = void 0;
    this.updated = void 0;
    this.createdByContactId = void 0;
    this.updatedByContactId = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/maintenance.model.ts